import { action, makeObservable, observable } from 'mobx';

import { ClaimPromoPayload, ClaimPromoResponse, HTTPResponse } from '../models';
import { HttpResponse, HttpResponseStatus, promoController } from '../api';
import { RootStore } from '.';

export class PromoStore {

  private rootStore: RootStore;

  public promoModalOpen = false;

  public claimPromoResponse = new HttpResponse<HTTPResponse<ClaimPromoResponse>>({ result: null }, HttpResponseStatus.Default);

  /**
   * @description NEW_PROMO_CODE_AVAILABLE is scheduled from the sidebar promo card, which remounts
   * on every promotions-tab visit - this guard keeps the notification scheduled once per session.
   * Not observable: nothing renders from it.
   */
  public promoNotificationScheduled = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      promoModalOpen: observable,
      setPromoModalOpen: action.bound,

      claimPromoResponse: observable,
      setClaimPromoResponse: action.bound,
    });
  }

  public setPromoModalOpen(value: boolean): void {
    this.promoModalOpen = value;
  }

  public setClaimPromoResponse(value: HttpResponse<HTTPResponse<ClaimPromoResponse>>): void {
    this.claimPromoResponse = value;
  }

  public resetClaimPromoResponse(): void {
    this.setClaimPromoResponse(this.claimPromoResponse.fetched({ result: null }));
  }

  public async claimPromo(payload: ClaimPromoPayload): Promise<void> {
    this.setClaimPromoResponse(this.claimPromoResponse.fetching());
    const data = await promoController.claimPromo(payload);
    this.setClaimPromoResponse(this.claimPromoResponse.fetched(data));
  }

}
